import { starterDeck } from "../builder";

export const ZH_RU_BASIC = starterDeck({
  id: "zh-ru-basic-a1",
  name: "Китайский — приветствия",
  name_en: "Chinese — Greetings",
  description: "Базовый набор иероглифов и фраз.",
  description_en: "A basic set of characters and phrases.",
  sourceLang: "zh",
  targetLang: "ru",
  topic: "basic",
  ageGroup: "adult",
  level: "A1",
  cards: [
    ["你好 (nǐ hǎo)", "Привет"],
    ["再见 (zàijiàn)", "До свидания"],
    ["谢谢 (xièxie)", "Спасибо"],
    ["不客气 (bú kèqi)", "Не за что", "phrase"],
    ["请 (qǐng)", "Пожалуйста / Прошу"],
    ["对不起 (duìbuqǐ)", "Извините"],
    ["是 (shì)", "Да / Быть"],
    ["不是 (bú shì)", "Нет / Не быть", "phrase"],
    ["我 (wǒ)", "Я"],
    ["你 (nǐ)", "Ты"],
    ["他 (tā)", "Он"],
    ["她 (tā)", "Она"],
    ["我们 (wǒmen)", "Мы"],
    ["你好吗？(nǐ hǎo ma?)", "Как дела?", "phrase"],
    ["我很好 (wǒ hěn hǎo)", "У меня всё хорошо", "phrase"],
    ["你叫什么名字？", "Как тебя зовут?", "phrase"],
    ["我叫… (wǒ jiào…)", "Меня зовут…", "phrase"],
    ["朋友 (péngyou)", "Друг"],
    ["家 (jiā)", "Дом / Семья"],
    ["爱 (ài)", "Любовь / Любить"],
  ],
});

export const ZH_EN_NUMBERS = starterDeck({
  id: "zh-en-numbers-a1",
  name: "Chinese numbers 1–10 (ZH→EN)",
  name_ru: "Китайские числа 1–10 (ZH→EN)",
  description: "Chinese numbers for counting, one to a thousand.",
  description_ru: "Китайские числительные для счёта — от одного до тысячи.",
  sourceLang: "zh",
  targetLang: "en",
  topic: "basic",
  ageGroup: "adult",
  level: "A1",
  cards: [
    ["一 (yī)", "one"],
    ["二 (èr)", "two"],
    ["三 (sān)", "three"],
    ["四 (sì)", "four"],
    ["五 (wǔ)", "five"],
    ["六 (liù)", "six"],
    ["七 (qī)", "seven"],
    ["八 (bā)", "eight"],
    ["九 (jiǔ)", "nine"],
    ["十 (shí)", "ten"],
    ["百 (bǎi)", "hundred"],
    ["千 (qiān)", "thousand"],
  ],
});

export const JA_EN_BASIC = starterDeck({
  id: "ja-en-basic-a1",
  name: "Japanese essentials (JA→EN)",
  name_ru: "Японский — основы (JA→EN)",
  description: "Greetings and polite phrases in hiragana/kanji.",
  description_ru: "Приветствия и вежливые фразы хираганой/кандзи.",
  sourceLang: "ja",
  targetLang: "en",
  topic: "basic",
  ageGroup: "adult",
  level: "A1",
  cards: [
    ["こんにちは (konnichiwa)", "Hello / Good afternoon", "phrase"],
    ["おはようございます (ohayō gozaimasu)", "Good morning", "phrase"],
    ["こんばんは (konbanwa)", "Good evening"],
    ["さようなら (sayōnara)", "Goodbye"],
    ["ありがとう (arigatō)", "Thank you"],
    ["ありがとうございます", "Thank you (polite)", "phrase"],
    ["どういたしまして", "You're welcome", "phrase"],
    ["すみません (sumimasen)", "Excuse me / Sorry", "phrase"],
    ["はい (hai)", "Yes"],
    ["いいえ (iie)", "No"],
    ["お願いします (onegai shimasu)", "Please", "phrase"],
    ["わたし (watashi)", "I / me"],
    ["あなた (anata)", "You"],
    ["名前は何ですか", "What is your name?", "phrase"],
    ["わたしは…です", "I am…", "phrase"],
    ["わかりません", "I don't understand", "phrase"],
    ["英語を話せますか", "Do you speak English?", "phrase"],
  ],
});
